/**
 * Events listeners
 */

window.addEventListener('load', function(){

    // Need to force Safari to reload all JS file.
    window.onpageshow = function(event) {
        if (event.persisted) {
            window.location.reload() 
        }
    };
    //======================= ANIMATE MENU ===========================
    $('.icon-container').click(function(){
        raymont.menu($(this));
    });

    //======================= ANIMATE DROPDOWNS ===========================
    $('.subMenuParent>span').click(function(event){
        if(event.stopPropagation) {
            event.stopPropagation();
        } else {
            event.cancelBubble = true;
        }

        raymont.dropdown($(this));
    });

    // Implemented for the 'Logistics solutions' menu.
    $('.menu > .dropdown').click(function(event){
        if(event.stopPropagation) {
            event.stopPropagation();
        } else {
            event.cancelBubble = true;
        }
        raymont.dropdown($(this).children());
    });


     
      
    //======================= CAROUSEL ===========================
    /*
    if($('.swiper-container').length > 0) {
        raymont.carousel();
    }
    */

    //======================= GLOBAL FREIGHT LOCATIONS ===========================
    if($('#mapFreight').length > 0) {
        raymont.mapFreight($('#mapFreight').get(0));
    }

    //======================= TRANSLOADING LOCATIONS ===========================
    if($('#mapTransloading').length > 0) {
        raymont.mapTransloading($('#mapTransloading').get(0), $('#website-lang').html());
    }

    //======================= YouTube Player ===================================
    if($('#player').length > 0) {
        raymont.videoPlayer();
    }
        

}); 